import { Injectable } from '@angular/core'
import { QueryGet } from '../../shared/query-types'
import { BehaviorSubject, Observable, tap } from 'rxjs'
import { Pagination } from '../../models/pagination.interface'
import { Outsider, OutsiderDTO } from '../../models/outsider.interface'
import { environment } from '../../../environments/environment'
import { RequestService } from '../request/request.service'
import {
    HttpClient,
    HttpErrorResponse,
    HttpHeaders,
} from '@angular/common/http'
import { AsyncFormValidation } from '../../interceptors/error.interceptor'

@Injectable({
    providedIn: 'root',
})
export class OutsiderService {
    httpOptions = {
        headers: new HttpHeaders({}),
    }
    private apiUrl = environment.service_1 + 'outsiders/'
    private outsiders = new BehaviorSubject<Outsider[]>([])
    outsiders$ = this.outsiders.asObservable()

    private outsidersSelected = new BehaviorSubject<Outsider | null>(null)
    $outsidersSelected = this.outsidersSelected.asObservable()

    private asyncErrorValidation =
        new BehaviorSubject<AsyncFormValidation | null>(null)
    asyncErrorValidation$ = this.asyncErrorValidation.asObservable()

    constructor(
        private requestService: RequestService,
        private http: HttpClient
    ) {}

    setOutsiders(outsiders: Outsider[]) {
        this.outsiders.next(outsiders)
    }

    setOutsider(outsider: Outsider) {
        this.outsidersSelected.next(outsider)
    }

    createOutsider(outsider: OutsiderDTO) {
        return this.http.post<OutsiderDTO>(this.apiUrl, outsider).pipe(
            tap({
                error: (err: HttpErrorResponse) => {
                    this.asyncErrorValidation.next(err.error)
                },
            })
        )
    }

    allOutsider(): Observable<Outsider[]> {
        return this.http.get<Outsider[]>(this.apiUrl, {
            headers: this.httpOptions.headers,
        })
    }

    allOutsiders(queryParams: QueryGet): Observable<Pagination<Outsider[]>> {
        return this.requestService.get<Outsider[]>(this.apiUrl, queryParams)
    }

    deleteOutsider(id: number): Observable<void> {
        return this.http.delete<void>(this.apiUrl + id + '/')
    }

    updateOutsider(id: number, outsider: OutsiderDTO & { id: number }) {
        return this.http.put<Outsider>(this.apiUrl + id + '/', outsider).pipe(
            tap({
                error: (err: HttpErrorResponse) => {
                    this.asyncErrorValidation.next(err.error)
                },
            })
        )
    }

    calculateAge(dateBirth: Date | null): number | null {
        if (!dateBirth) return null
        const birth = new Date(
            dateBirth.getFullYear(),
            dateBirth.getMonth(),
            dateBirth.getDate()
        )
        const today = new Date()
        let age = today.getFullYear() - birth.getFullYear()
        const m = today.getMonth() - birth.getMonth()
        if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--
        return age
    }
}
